<div class="abs-container">
  <timepicker [(ngModel)]="selectedTime" [showMeridian]="true" (ngModelChange)="onTimeChange($event)"></timepicker>
</div>